var map = {
	"./SH10RT_Battery_Specification.pdf": 1309,
	"./SP_Pro_Battery_Specification.pdf": 2634,
	"./icons/Home": 8525,
	"./icons/Home.jsx": 8525,
	"./icons/Operations": 6117,
	"./icons/Operations.jsx": 6117,
	"./icons/Performance": 4875,
	"./icons/Performance.jsx": 4875,
	"./icons/Pin": 8715,
	"./icons/Pin.jsx": 8715,
	"./icons/Reports": 9807,
	"./icons/Reports.jsx": 9807,
	"./img/alarm.svg": 3672,
	"./img/arrow_down.svg": 1922,
	"./img/batteries/charging/100.svg": 2008,
	"./img/batteries/charging/25.svg": 3468,
	"./img/batteries/charging/50.svg": 4915,
	"./img/batteries/charging/75.svg": 4827,
	"./img/batteries/discharging/100.svg": 1077,
	"./img/batteries/discharging/25.svg": 6480,
	"./img/batteries/discharging/50.svg": 1029,
	"./img/batteries/discharging/75.svg": 3320,
	"./img/batteries/error/100.svg": 301,
	"./img/batteries/error/25.svg": 658,
	"./img/batteries/error/50.svg": 3259,
	"./img/batteries/error/75.svg": 4932,
	"./img/batteries/idle/100.svg": 1261,
	"./img/batteries/idle/25.svg": 8621,
	"./img/batteries/idle/50.svg": 9245,
	"./img/batteries/idle/75.svg": 4373,
	"./img/battery-icon.svg": 7994,
	"./img/card_bg.svg": 8706,
	"./img/dermand.svg": 1563,
	"./img/download.svg": 4335,
	"./img/excel.svg": 1443,
	"./img/flex-icon.svg": 3374,
	"./img/grid-purchases-bg.svg": 6207,
	"./img/grid.svg": 5781,
	"./img/location-icon.svg": 7782,
	"./img/logo.svg": 5522,
	"./img/logo_microsoft.svg": 2138,
	"./img/map/pin-active.svg": 4680,
	"./img/map/pin.svg": 6750,
	"./img/offline.svg": 5897,
	"./img/panels/offline.svg": 9094,
	"./img/panels/online.svg": 7764,
	"./img/panels/optimal.svg": 1631,
	"./img/panels/sub-optimal.svg": 1007,
	"./img/pdf.svg": 35,
	"./img/performance-card-bg.svg": 4948,
	"./img/solar-icon.svg": 9502,
	"./img/user.svg": 6743,
	"./img/weather/cloud.svg": 3185,
	"./img/weather/partly_cloudy.svg": 368,
	"./img/weather/rain.svg": 8352,
	"./img/weather/snow.svg": 5407,
	"./img/weather/sun.svg": 9374,
	"./img/weather/thunderstorm.svg": 5119,
	"./test.pdf": 2519,
	"./test.xls": 9049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;